// authReducer.js
const initialState = {
    token: null,
    username: null,
    error: null,
  };
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOGIN_SUCCESS':
        return {
          ...state,
          token: action.payload.token,
          username: action.payload.username,
          error: null,
        };
      case 'LOGIN_FAILURE':
        return {
          ...state,
          token: null,
          username: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default authReducer;
  